// extracted by mini-css-extract-plugin
module.exports = {"root":"Background_root__UNi1b","image":"Background_image__9cAp0","overlay":"Background_overlay__pl8bG"};